/**
 *
 * @param ruleData
 */
export function getAbilityScoreDisplayTypes(ruleData) {
    var _a;
    return (_a = ruleData.abilityScoreDisplayTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAbilitySkills(ruleData) {
    var _a;
    return (_a = ruleData.abilitySkills) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getActivationTypes(ruleData) {
    var _a;
    return (_a = ruleData.activationTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAdditionalLevelTypes(ruleData) {
    var _a;
    return (_a = ruleData.additionalLevelTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAdjustmentDataTypes(ruleData) {
    var _a;
    return (_a = ruleData.adjustmentDataTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAdjustmentTypes(ruleData) {
    var _a;
    return (_a = ruleData.adjustmentTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAlignments(ruleData) {
    var _a;
    return (_a = ruleData.alignments) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAoeTypes(ruleData) {
    var _a;
    return (_a = ruleData.aoeTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getArmor(ruleData) {
    var _a;
    return (_a = ruleData.armor) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getArmorTypes(ruleData) {
    var _a;
    return (_a = ruleData.armorTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getBaseWeaponReach(ruleData) {
    return ruleData.baseWeaponReach;
}
/**
 *
 * @param ruleData
 */
export function getBasicActions(ruleData) {
    var _a;
    return (_a = ruleData.basicActions) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getBasicMaxStatScore(ruleData) {
    return ruleData.basicMaxStatScore;
}
/**
 *
 * @param ruleData
 * @returns {Array<BuilderHelperTextInfoContract>}
 */
export function getBuilderHelperText(ruleData) {
    return ruleData.builderHelperText;
}
/**
 *
 * @param ruleData
 */
export function getChallengeRatings(ruleData) {
    var _a;
    return (_a = ruleData.challengeRatings) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getClassSpellTypeId(ruleData) {
    return ruleData.classSpellTypeId;
}
/**
 *
 * @param ruleData
 */
export function getConditionTypes(ruleData) {
    var _a;
    return (_a = ruleData.conditionTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getConditions(ruleData) {
    var _a;
    return (_a = ruleData.conditions) !== null && _a !== void 0 ? _a : [];
}
export function getCoverTypes(ruleData) {
    var _a;
    return (_a = ruleData.coverTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getCreatureGroupCategories(ruleData) {
    var _a;
    return (_a = ruleData.creatureGroupCategories) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getCreatureGroupFlags(ruleData) {
    var _a;
    return (_a = ruleData.creatureGroupFlags) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getCreatureGroups(ruleData) {
    var _a;
    return (_a = ruleData.creatureGroups) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getCreatureSizes(ruleData) {
    var _a;
    return (_a = ruleData.creatureSizes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getCurrencyData(ruleData) {
    var _a;
    return (_a = ruleData.currencyData) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getDamageAdjustments(ruleData) {
    var _a;
    return (_a = ruleData.damageAdjustments) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getDamageTypes(ruleData) {
    var _a;
    return (_a = ruleData.damageTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getDefaultArmorImageUrl(ruleData) {
    return ruleData.defaultArmorImageUrl;
}
/**
 *
 * @param ruleData
 */
export function getDefaultGearImageUrl(ruleData) {
    return ruleData.defaultGearImageUrl;
}
/**
 *
 * @param ruleData
 */
export function getDefaultRaceImageUrl(ruleData) {
    return ruleData.defaultRacePortraitUrl;
}
/**
 *
 * @param ruleData
 */
export function getDefaultWeaponImageUrl(ruleData) {
    return ruleData.defaultWeaponImageUrl;
}
/**
 *
 * @param ruleData
 */
export function getDiceValues(ruleData) {
    var _a;
    return (_a = ruleData.diceValues) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getEnvironments(ruleData) {
    var _a;
    return (_a = ruleData.environments) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getGearTypes(ruleData) {
    var _a;
    return (_a = ruleData.gearTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getInitiativeScore(ruleData) {
    return ruleData.initiativeScore;
}
/**
 *
 * @param ruleData
 */
export function getLanguageTypeId(ruleData) {
    return ruleData.languageTypeId;
}
/**
 *
 * @param ruleData
 */
export function getLanguages(ruleData) {
    var _a;
    return (_a = ruleData.languages) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getLevelExperiencePoints(ruleData) {
    var _a;
    return (_a = ruleData.levelExperiencePoints) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getLevelProficiencyBonuses(ruleData) {
    var _a;
    return (_a = ruleData.levelProficiencyBonuses) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getLifestyles(ruleData) {
    var _a;
    return (_a = ruleData.lifestyles) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getLimitedUseResetTypes(ruleData) {
    var _a;
    return (_a = ruleData.limitedUseResetTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getLongRestMinimumHitDiceUsedRecovered(ruleData) {
    return ruleData.longRestMinimumHitDiceUsedRecovered;
}
/**
 *
 * @param ruleData
 */
export function getDefaultAttunedItemCountMax(ruleData) {
    return ruleData.defaultAttunedItemCountMax;
}
/**
 *
 * @param ruleData
 */
export function getMaxAttunedItemCountMax(ruleData) {
    return ruleData.maxAttunedItemCountMax;
}
/**
 *
 * @param ruleData
 */
export function getMinAttunedItemCountMax(ruleData) {
    return ruleData.minAttunedItemCountMax;
}
/**
 *
 * @param ruleData
 */
export function getMaxCharacterLevel(ruleData) {
    return ruleData.maxCharacterLevel;
}
/**
 *
 * @param ruleData
 */
export function getMaxDeathsavesFail(ruleData) {
    return ruleData.maxDeathsavesFail;
}
/**
 *
 * @param ruleData
 */
export function getMaxDeathsavesSuccess(ruleData) {
    return ruleData.maxDeathsavesSuccess;
}
/**
 *
 * @param ruleData
 */
export function getMaxSpellLevel(ruleData) {
    return ruleData.maxSpellLevel;
}
/**
 *
 * @param ruleData
 */
export function getMaxStatScore(ruleData) {
    return ruleData.maxStatScore;
}
/**
 *
 * @param ruleData
 */
export function getMinStatScore(ruleData) {
    return ruleData.minStatScore;
}
/**
 *
 * @param ruleData
 */
export function getMinimumHpTotal(ruleData) {
    return ruleData.minimumHpTotal;
}
/**
 *
 * @param ruleData
 */
export function getMinimumLimitedUseMaxUse(ruleData) {
    return ruleData.minimumLimitedUseMaxUse;
}
/**
 *
 * @param ruleData
 */
export function getMonsterSubTypes(ruleData) {
    var _a;
    return (_a = ruleData.monsterSubTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getMonsterTypes(ruleData) {
    var _a;
    return (_a = ruleData.monsterTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getMovements(ruleData) {
    var _a;
    return (_a = ruleData.movements) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getMultiClassSpellSlots(ruleData) {
    var _a;
    let fallback = [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
    ];
    return (_a = ruleData.multiClassSpellSlots) !== null && _a !== void 0 ? _a : fallback;
}
/**
 *
 * @param ruleData
 */
export function getNaturalActions(ruleData) {
    var _a;
    return (_a = ruleData.naturalActions) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getNoArmorAcAmount(ruleData) {
    return ruleData.noArmorAcAmount;
}
/**
 *
 * @param ruleData
 */
export function getPactMagicMultiClassSpellSlots(ruleData) {
    var _a;
    let fallback = [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
    ];
    return (_a = ruleData.pactMagicMultiClassSpellSlots) !== null && _a !== void 0 ? _a : fallback;
}
/**
 *
 * @param ruleData
 */
export function getPrivacyTypes(ruleData) {
    var _a;
    return (_a = ruleData.privacyTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getProficiencyGroups(ruleData) {
    var _a;
    return (_a = ruleData.proficiencyGroups) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getRaceGroups(ruleData) {
    var _a;
    return (_a = ruleData.raceGroups) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getRangeTypes(ruleData) {
    var _a;
    return (_a = ruleData.rangeTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getRestoreTypes(ruleData) {
    var _a;
    return (_a = ruleData.restoreTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getRitualCastingTimeMinuteAddition(ruleData) {
    return ruleData.ritualCastingTimeMinuteAddition;
}
/**
 *
 * @param ruleData
 */
export function getRules(ruleData) {
    var _a;
    return (_a = ruleData.rules) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSenses(ruleData) {
    var _a;
    return (_a = ruleData.senses) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSharingTypes(ruleData) {
    var _a;
    return (_a = ruleData.sharingTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSourceCategories(ruleData) {
    var _a;
    return (_a = ruleData.sourceCategories) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSourceCategoryLookup(ruleData) {
    return ruleData.sourceCategoryLookup;
}
/**
 *
 * @param ruleData
 */
export function getSources(ruleData) {
    var _a;
    return (_a = ruleData.sources) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSpellComponents(ruleData) {
    var _a;
    return (_a = ruleData.spellComponents) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSpellConditionTypes(ruleData) {
    var _a;
    return (_a = ruleData.spellConditionTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getSpellRangeTypes(ruleData) {
    var _a;
    return (_a = ruleData.spellRangeTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getStatModifiers(ruleData) {
    var _a;
    return (_a = ruleData.statModifiers) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getStats(ruleData) {
    var _a;
    return (_a = ruleData.stats) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getStealthCheckTypes(ruleData) {
    var _a;
    return (_a = ruleData.stealthCheckTypes) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getStringMartialArts(ruleData) {
    return ruleData.stringMartialArts;
}
/**
 *
 * @param ruleData
 */
export function getStringPactMagic(ruleData) {
    return ruleData.stringPactMagic;
}
/**
 *
 * @param ruleData
 */
export function getStringSpellCasting(ruleData) {
    return ruleData.stringSpellCasting;
}
/**
 *
 * @param ruleData
 */
export function getStringSpellEldritchBlast(ruleData) {
    return ruleData.stringSpellEldritchBlast;
}
/**
 *
 * @param ruleData
 */
export function getToolTypeId(ruleData) {
    return ruleData.toolTypeId;
}
/**
 *
 * @param ruleData
 */
export function getTools(ruleData) {
    var _a;
    return (_a = ruleData.tools) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getWeaponCategories(ruleData) {
    var _a;
    return (_a = ruleData.weaponCategories) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getWeaponProperties(ruleData) {
    var _a;
    return (_a = ruleData.weaponProperties) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getWeaponPropertyReachDistance(ruleData) {
    return ruleData.weaponPropertyReachDistance;
}
/**
 *
 * @param ruleData
 */
export function getWeapons(ruleData) {
    var _a;
    return (_a = ruleData.weapons) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param ruleData
 */
export function getAbilitySkillLookup(ruleData) {
    return ruleData.abilitySkillLookup;
}
/**
 *
 * @param ruleData
 */
export function getActivationTypesLookup(ruleData) {
    return ruleData.activationTypesLookup;
}
/**
 *
 * @param ruleData
 */
export function getAdjustmentDataTypesLookup(ruleData) {
    return ruleData.adjustmentDataTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getAdjustmentTypesLookup(ruleData) {
    return ruleData.adjustmentTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getAlignmentLookup(ruleData) {
    return ruleData.alignmentLookup;
}
export function getLifestyleLookup(ruleData) {
    return ruleData.lifestyleLookup;
}
/**
 *
 * @param ruleData
 */
export function getAoeTypeLookup(ruleData) {
    return ruleData.aoeTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getBasicActionsLookup(ruleData) {
    return ruleData.basicActionLookup;
}
/**
 *
 * @param ruleData
 */
export function getChallengeRatingLookup(ruleData) {
    return ruleData.challengeRatingLookup;
}
/**
 *
 * @param ruleData
 */
export function getConditionLookup(ruleData) {
    return ruleData.conditionLookup;
}
/**
 *
 * @param ruleData
 */
export function getCreatureGroupCategoryLookup(ruleData) {
    return ruleData.creatureGroupCategoryLookup;
}
/**
 *
 * @param ruleData
 */
export function getCreatureGroupFlagLookup(ruleData) {
    return ruleData.creatureGroupFlagLookup;
}
/**
 *
 * @param ruleData
 */
export function getCreatureGroupLookup(ruleData) {
    return ruleData.creatureGroupLookup;
}
/**
 *
 * @param ruleData
 */
export function getCreatureSizeLookup(ruleData) {
    return ruleData.creatureSizeLookup;
}
/**
 *
 * @param ruleData
 */
export function getCurrencyDataLookup(ruleData) {
    return ruleData.currencyDataLookup;
}
/**
 *
 * @param ruleData
 */
export function getCoverTypeLookup(ruleData) {
    return ruleData.coverTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getDamageAdjustmentsLookup(ruleData) {
    return ruleData.damageAdjustmentsLookup;
}
/**
 *
 * @param ruleData
 */
export function getDamageTypeLookup(ruleData) {
    return ruleData.damageTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getEnvironmentLookup(ruleData) {
    return ruleData.environmentLookup;
}
/**
 *
 * @param ruleData
 */
export function getImmunityDamageAdjustments(ruleData) {
    return ruleData.immunityDamageAdjustments;
}
/**
 *
 * @param ruleData
 */
export function getLanguageLookup(ruleData) {
    return ruleData.languageLookup;
}
/**
 *
 * @param ruleData
 */
export function getLevelProficiencyBonusesLookup(ruleData) {
    return ruleData.levelProficiencyBonusesLookup;
}
/**
 *
 * @param ruleData
 */
export function getLimitedUseResetTypeLookup(ruleData) {
    return ruleData.limitedUseResetTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getMonsterSubTypeLookup(ruleData) {
    return ruleData.monsterSubTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getMonsterTypeLookup(ruleData) {
    return ruleData.monsterTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getMovementLookup(ruleData) {
    return ruleData.movementLookup;
}
/**
 *
 * @param ruleData
 */
export function getRangeTypeLookup(ruleData) {
    return ruleData.rangeTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getResistanceDamageAdjustments(ruleData) {
    return ruleData.resistanceDamageAdjustments;
}
/**
 *
 * @param ruleData
 */
export function getRuleLookup(ruleData) {
    return ruleData.ruleLookup;
}
/**
 *
 * @param ruleData
 */
export function getSenseLookup(ruleData) {
    return ruleData.senseLookup;
}
/**
 *
 * @param ruleData
 */
export function getSpellComponentsLookup(ruleData) {
    return ruleData.spellComponentsLookup;
}
/**
 *
 * @param ruleData
 */
export function getSpellRangeTypeLookup(ruleData) {
    return ruleData.spellRangeTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getStatModifiersLookup(ruleData) {
    return ruleData.statModifiersLookup;
}
/**
 *
 * @param ruleData
 */
export function getStatsLookup(ruleData) {
    return ruleData.statsLookup;
}
/**
 *
 * @param ruleData
 */
export function getStatKeyLookup(ruleData) {
    return ruleData.statKeyLookup;
}
/**
 *
 * @param ruleData
 */
export function getStealthCheckTypeLookup(ruleData) {
    return ruleData.stealthCheckTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getVersatileDieLookup(ruleData) {
    return ruleData.versatileDieLookup;
}
/**
 *
 * @param ruleData
 */
export function getVulnerabilityDamageAdjustments(ruleData) {
    return ruleData.vulnerabilityDamageAdjustments;
}
/**
 *
 * @param ruleData
 */
export function getWeaponCategoryLookup(ruleData) {
    return ruleData.weaponCategoryLookup;
}
/**
 *
 * @param ruleData
 */
export function getWeaponLookupByEntityId(ruleData) {
    return ruleData.weaponLookupByEntityId;
}
/**
 *
 * @param ruleData
 */
export function getSourceDataLookup(ruleData) {
    return ruleData.sourceDataLookup;
}
/**
 *
 * @param ruleData
 */
export function getSourceData(ruleData) {
    return ruleData.sourceData;
}
/**
 *
 * @param ruleData
 */
export function getVehicleRuleData(ruleData) {
    return ruleData.vehicleRuleData;
}
/**
 *
 * @param ruleData
 */
export function getVehicleDimensionRanges(ruleData) {
    var _a, _b;
    return (_b = (_a = getVehicleRuleData(ruleData)) === null || _a === void 0 ? void 0 : _a.vehicleDimensionRanges) !== null && _b !== void 0 ? _b : [];
}
/**
 *
 * @param ruleData
 */
export function getVehicleWeightRanges(ruleData) {
    var _a, _b;
    return (_b = (_a = getVehicleRuleData(ruleData)) === null || _a === void 0 ? void 0 : _a.vehicleWeightRanges) !== null && _b !== void 0 ? _b : [];
}
/**
 *
 * @param ruleData
 */
export function getVehicleMovementTypes(ruleData) {
    var _a, _b;
    return (_b = (_a = getVehicleRuleData(ruleData)) === null || _a === void 0 ? void 0 : _a.vehicleMovementTypes) !== null && _b !== void 0 ? _b : [];
}
/**
 *
 * @param ruleData
 */
export function getObjectTypes(ruleData) {
    var _a, _b;
    return (_b = (_a = getVehicleRuleData(ruleData)) === null || _a === void 0 ? void 0 : _a.objectTypes) !== null && _b !== void 0 ? _b : [];
}
/**
 *
 * @param ruleData
 */
export function getComponentTypes(ruleData) {
    var _a, _b;
    return (_b = (_a = getVehicleRuleData(ruleData)) === null || _a === void 0 ? void 0 : _a.componentTypes) !== null && _b !== void 0 ? _b : [];
}
/**
 *
 * @param ruleData
 */
export function getVehicleMovementLookup(ruleData) {
    return ruleData.vehicleMovementLookup;
}
/**
 *
 * @param ruleData
 */
export function getObjectTypeLookup(ruleData) {
    return ruleData.objectTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getComponentTypeLookup(ruleData) {
    return ruleData.componentTypeLookup;
}
/**
 *
 * @param ruleData
 */
export function getArmorTypeLookup(ruleData) {
    return ruleData.armorTypeLookup;
}
